const SILO_ACCESSOR = Symbol.for('silo_v1');
/* This file is compiled with simple-cjs-loader before being inlined into apps' HTML.
 * In that context, we're restricted from:
 * - Importing anything other than types
 * - Exporting anything other than types and function declarations
 *
 * Exports that do not follow this rule are eliminated by the loader, but so long as we don't
 * **export** it, variables can still be defined and used (e.g SILO_ACCESSOR).
 *
 * Some of the functions in this file are imported elsewhere and called at runtime
 * to ensure behavior is kept in sync between the two contexts.
 *
 * Everything below this point **must** use only function declarations and non-exported values
 * **from this file**.
 */

export function makeScopedState(...initialValues) {
  return {
    values: new Map(initialValues),
    watchers: new Map()
  };
}
export function getBuildTimePropertyNames() {
  return {
    breezeAssistantEnabled: 'breeze_assistant_enabled',
    breezeAssistantSidebarBackground: 'breeze_assistant_sidebar_background',
    copilotLayoutType: 'copilot_layout_type',
    copilotSidebarSide: 'copilot_sidebar_side',
    currentPackageName: 'current_package_name',
    currentPackageVersion: 'current_package_version',
    rootPackageName: 'root_package_name',
    rootPackageVersion: 'root_package_version'
  };
}
function getCopilotSidebarSideFromSessionStorage() {
  try {
    // Key must match COPILOT_SIDEBAR_SIDE in quartz-core/static/js/internal/copilot.tsx
    return sessionStorage.getItem('copilot-sidebar-side') === 'left' ? 'left' : 'right';
  } catch (e) {
    return 'right';
  }
}

// Mirrors PortalIdParser's parsing logic. This file cannot import runtime
// dependencies, so the regexes are inlined here.
function getPortalIdFromUrl() {
  try {
    const pathMatch = window.location.pathname.match(/^\/(?:[A-Za-z0-9-_]*)\/(\d+)(?:\/|$)/);
    if (pathMatch) {
      return pathMatch[1];
    }
    const queryMatch = window.location.search.match(/(?:\?|&)portalid=(\d+)/i);
    if (queryMatch) {
      return queryMatch[1];
    }
    return null;
  } catch (e) {
    return null;
  }
}
function getCopilotSidebarSideFromLocalStorage() {
  try {
    // Key must match COPILOT_SIDEBAR_SIDE_GATE in chatspot-core/static/js/constants/LocalStorage.ts
    const value = localStorage.getItem('copilot-sidebar-side-gate');
    if (value === 'left' || value === 'right') {
      return value;
    }
    if (!value) {
      return null;
    }
    let portalMap;
    try {
      portalMap = JSON.parse(value);
    } catch (e) {
      return null;
    }
    if (!portalMap || typeof portalMap !== 'object') {
      return null;
    }
    const portalId = getPortalIdFromUrl();
    if (!portalId) {
      return null;
    }
    const sideForPortal = portalMap[portalId];
    return sideForPortal === 'left' || sideForPortal === 'right' ? sideForPortal : null;
  } catch (e) {
    return null;
  }
}
export function getGlobalState(win = window) {
  return win[SILO_ACCESSOR];
}

// Parameters are injected at build time
export function initialize(appName, appVersion, copilotLayoutType, copilotSidebarSide, breezeAssistantEnabled, sidebarBackground) {
  var _nearestAncestor$SILO, _ref;
  if (getGlobalState()) {
    throw Error('Global state already initialized');
  }
  let nearestAncestor = window;
  while (nearestAncestor.parent !== nearestAncestor) {
    try {
      // Will throw when the parent window is from a different domain
      const __sameOriginTest = nearestAncestor.parent.document;
      nearestAncestor = nearestAncestor.parent;
      if (getGlobalState(nearestAncestor.parent)) {
        break;
      }
    } catch (e) {
      // Skip different origin frame
      break;
    }
  }
  const {
    breezeAssistantEnabled: breezeAssistantEnabledPropertyName,
    breezeAssistantSidebarBackground: breezeAssistantSidebarBackgroundPropertyName,
    copilotLayoutType: copilotLayoutTypePropertyName,
    copilotSidebarSide: copilotSidebarSidePropertyName,
    currentPackageName,
    currentPackageVersion,
    rootPackageName,
    rootPackageVersion
  } = getBuildTimePropertyNames();
  window[SILO_ACCESSOR] = {
    TAB: ((_nearestAncestor$SILO = nearestAncestor[SILO_ACCESSOR]) === null || _nearestAncestor$SILO === void 0 ? void 0 : _nearestAncestor$SILO.TAB) || makeScopedState([rootPackageName, appName], [rootPackageVersion, appVersion]),
    BROWSING_CONTEXT: makeScopedState([currentPackageName, appName], [currentPackageVersion, appVersion], [copilotLayoutTypePropertyName, copilotLayoutType], [copilotSidebarSidePropertyName, (_ref = copilotSidebarSide !== null && copilotSidebarSide !== void 0 ? copilotSidebarSide : getCopilotSidebarSideFromLocalStorage()) !== null && _ref !== void 0 ? _ref : getCopilotSidebarSideFromSessionStorage()], [breezeAssistantEnabledPropertyName, breezeAssistantEnabled !== null && breezeAssistantEnabled !== void 0 ? breezeAssistantEnabled : true], [breezeAssistantSidebarBackgroundPropertyName, sidebarBackground])
  };
}